import { ResetPassword } from './../_models/ResetPassword';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SignUp } from '../_models/sign-up';


@Injectable({
  providedIn: 'root'
})
export class SignUpService {

  constructor(private http: HttpClient) { }

 
  public static readonly SIGN_UP_CONTROLLER_URL=environment.apiURL+"signUp/"
  public static readonly SIGN_UP_CONTROLLER_RESET_PASSWORD_URL = environment.apiURL+"resetPassword"
  
  public signUp(signUpDataForm: SignUp):Observable<HttpResponse<SignUp>>{
    {
      return this.http.post<SignUp>(SignUpService.SIGN_UP_CONTROLLER_URL , signUpDataForm ,{ observe: 'response' })
      .pipe(map(response => {
        return response;
      }));
    }
  }

  public resetPassword(resetFormGroup: ResetPassword):Observable<HttpResponse<ResetPassword>>{
    return this.http.post<ResetPassword>(SignUpService.SIGN_UP_CONTROLLER_RESET_PASSWORD_URL , resetFormGroup ,{ observe: 'response' })
    .pipe(map(response => {
      return response;
  }));
}
}
